import { RATE_CARD_TYPE_PRICING, TMultiRatePrice, TRateCard } from '@types';

type TAnyPrice = TRateCard | TMultiRatePrice | null | undefined;

const MULTI_RATE_METHODS: string[] = [
	RATE_CARD_TYPE_PRICING.PER_ITEM,
	RATE_CARD_TYPE_PRICING.PER_SPACE,
	RATE_CARD_TYPE_PRICING.COST_PER_KG
];

/** Whether the payload prices on shipment-api v2: its method is one only v2 knows. */
export const isMultiRatePayload = (payload?: { pricing_method?: string | null } | null): boolean =>
	!!payload?.pricing_method && MULTI_RATE_METHODS.includes(payload.pricing_method);

/** A multi-rate payload as the v1 store takes it: switched on by `is_multi_rate`. */
export const toMultiRateStorePayload = <T extends { pricing_method?: string | null }>(payload: T): T & { is_multi_rate: true } =>
	({ ...payload, is_multi_rate: true });

/** A multi-rate price carries the shape flag and one item per cargo row, whatever its method. */
export const isMultiRatePrice = (price: TAnyPrice): price is TMultiRatePrice =>
	price?.isMultiRate === true && Array.isArray(price.items);

/** The card whose figures describe the whole price: a single-card price itself, or the one card a COST_PER_KG or PER_SPACE multi-rate price is priced on. */
export const singleCardOf = (price: TAnyPrice): TRateCard | null => {
	if (!price) return null;
	if (!isMultiRatePrice(price)) return price;
	return price.pricingMethod === RATE_CARD_TYPE_PRICING.COST_PER_KG || price.pricingMethod === RATE_CARD_TYPE_PRICING.PER_SPACE
		? price.items[0] ?? null
		: null;
};

/** Tells one listed price from another: rate card or lane, per freight mode (a lane prices every mode). */
export const priceKeyOf = (price: TAnyPrice): string | undefined =>
	price ? `${price.rateCardExternalId ?? price.laneId}:${price.freightMode}` : undefined;
